"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_if_1 = require("react-if");
const reactstrap_1 = require("reactstrap");
const react_2 = require("@osmosys/react");
const CreateResourcesButton_1 = require("../../../comps/reusables/CreateResourcesButton");
const svg_1 = require("../../../svg");
const graphql_1 = require("../../../graphql");
const Yup = tslib_1.__importStar(require("yup"));
const use_react_router_1 = tslib_1.__importDefault(require("use-react-router"));
const inputs_1 = require("../../../inputs");
const react_router_dom_1 = require("react-router-dom");
// interface IState {}
exports.EmailTemplateList = () => {
    const { history } = use_react_router_1.default();
    const usasHistory = react_router_dom_1.useHistory();
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_2.OsmosysListLayout, { pathToItems: "emailTemplates", pathToCount: "emailTemplatesCount", showReloadButton: true, query: {
                query: graphql_1.emailTemplates,
            }, 
            // subscription={{
            //   actionKey: 'emailTemplatesChange',
            //   query: emailTemplatesChange,
            //   resourceKey: 'emailTemplate',
            // }}
            itemName: "template", itemsName: "templates", toolbarLeft: () => {
                return (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(CreateResourcesButton_1.CreateResourcesButton, { label: "New email template", modalProps: {
                            formProps: {
                                formikProps: {
                                    initialValues: {
                                        name: '',
                                    },
                                    validationSchema: Yup.object().shape({
                                        name: Yup.string().required('name is a required field'),
                                    }),
                                },
                                mutationProps: {
                                    mutation: graphql_1.createEmailTemplate,
                                    onCompleted: data => {
                                        history.push(`/templates/${data.createEmailTemplate.id}`);
                                    },
                                },
                                valuesToVariables: values => {
                                    return {
                                        data: {
                                            html: values.html,
                                            name: values.name,
                                        },
                                    };
                                },
                            },
                            header: 'New email template',
                        } }),
                    react_1.default.createElement(inputs_1.OsmosysResourceSelectBox, { resource: "emailTemplate", label: false, onChange: (emailTemplate) => {
                            usasHistory.push(`/templates/${emailTemplate.id}`);
                        } })));
            }, 
            // toolbarRight={() => {
            //   return (
            //     <Button
            //       tag="a"
            //       href="https://gist.github.com/charlex/23b1c5fd51bf801615559ee9457521cd"
            //     >
            //       Documentation
            //     </Button>
            //   );
            // }}
            itemProps: ({ createdAt, id, name, stagingVersion, productionVersion, developmentVersion, }) => {
                // const tags = [];
                // if (item.productionVersion) {
                //   tags.push({
                //     children: `${item.productionVersion.version} is deployed to production`,
                //   });
                // }
                return {
                    body: !!(productionVersion ||
                        stagingVersion ||
                        developmentVersion) && (react_1.default.createElement("div", null,
                        react_1.default.createElement(react_if_1.When, { condition: !!productionVersion }, () => (react_1.default.createElement(react_2.OsmosysTooltip, { label: "Production", span: true },
                            react_1.default.createElement(reactstrap_1.Badge, { color: "danger", className: "progress-bar-striped" },
                                react_1.default.createElement(react_1.default.Fragment, null, productionVersion.version))))),
                        react_1.default.createElement("div", { className: "mx-1 d-inline" }, " "),
                        react_1.default.createElement(react_if_1.When, { condition: !!stagingVersion }, () => (react_1.default.createElement(react_2.OsmosysTooltip, { label: "Staging", span: true },
                            react_1.default.createElement(reactstrap_1.Badge, { color: "warning", className: "progress-bar-striped" },
                                react_1.default.createElement(react_1.default.Fragment, null, stagingVersion.version))))),
                        react_1.default.createElement(react_if_1.When, { condition: !!developmentVersion }, () => (react_1.default.createElement(react_2.OsmosysTooltip, { label: "Development", span: true },
                            react_1.default.createElement(reactstrap_1.Badge, { color: "success", className: "progress-bar-striped" },
                                react_1.default.createElement(react_1.default.Fragment, null, developmentVersion.version))))))),
                    createdAt,
                    icon: react_1.default.createElement(svg_1.TemplatesLogo2, { width: "64", height: "64" }),
                    linkURL: `/templates/${id}`,
                    title: name,
                };
            } })));
};
exports.default = exports.EmailTemplateList;
//# sourceMappingURL=index.js.map